import { getRequest } from "../../config/axiosConfig";

export const getAllCards = async () => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "health-card/patient/fetch",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "health card retrieved Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "failed health card retrival request.",
    };
  }
};
